<template>
  <div class="consultant-container">
    <!-- 🔹 Оверлей загрузки -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="spinner"></div>
    </div>

    <!-- 🔹 Основной контент -->
    <div class="question-row">
      <h2 class="title">Персональный карьерный ассистент?</h2>
      <label class="switch">
        <input type="checkbox" v-model="isConsultant" />
        <span class="slider"></span>
      </label>
    </div>

    <div class="slider-row" v-if="isConsultant">
      <p class="subtitle">
        Укажите Ваш примерный опыт работы в найме/на себя в данной сфере.
      </p>    
    </div>

    <div class="slider-row" v-if="isConsultant">        
      <span class="experience-label">Ваш примерный опыт</span>
      <span class="experience-value">{{ experience }} </span>
    </div>

    <input 
      v-if="isConsultant"
      type="range"
      min="1"
      max="10"
      step="1"
      v-model="experience"
      class="experience-slider"
    />

    <ErrorToast v-if="errorMessage" :message="errorMessage" />
    <WarningToast v-if="warningMessage" :message="warningMessage" />
    <Snackbar :message="'Данные успешно обновлены!'" :type="'success'" :show="successSnackbar" />
  </div>
</template>
  
  <script setup>
  import { ref, defineEmits } from 'vue';
  import ConsultantService from '../../api/ConsultantService.js';
  import ErrorToast from "../../components/ErrorToast.vue"
  import WarningToast from "../../components/WarningToast.vue"
  import Snackbar from "../../components/Snackbar.vue";
  
  const successSnackbar = ref(false);
  const errorMessage = ref("");
  const warningMessage = ref("");

  const emit = defineEmits(['save-consultant']);
  
  const isConsultant = ref(false);
  const experience = ref(3);
  const isLoading = ref(false);
    
  const saveConsultant = async () => {
    isLoading.value = true;

    try {
      const isConsultantValue = isConsultant.value;
      const consultantExperienceValue = isConsultantValue ? Number(experience.value) : 0;

      const result = await ConsultantService.updateConsultantStatus(
        isConsultantValue,
        consultantExperienceValue
      );

      if (result?.message === "Профиль обновлён") {
        successSnackbar.value = true;
      } else {
        errorMessage.value = "⚠️ Не удалось сохранить данные консультанта";
      }

      emit("save-consultant");

    } catch (error) {
      console.error("❌ Ошибка при сохранении данных консультанта:", error);
      errorMessage.value = "🔥 Ошибка при сохранении данных консультанта";
    } finally {
      isLoading.value = false;
    }
  };
  
  defineExpose({ saveConsultant });

  </script>
  
  <style scoped>

  .consultant-container {
    width: 600px;
    font-family: "Eastman-Regular", sans-serif;
  }
  
  .question-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .title {
    font-size: 20px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--header-text-dark);
  }
  
  [data-theme="light"] .title {
    color: var(--header-text-light);
  }
  
  .subtitle {
    margin-top: 20px;
    font-size: 14px;
    color: var(--text-muted-dark);
  }
  
  [data-theme="light"] .subtitle {
    color: var(--text-muted-light);
  }
  
  .slider-row {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    margin-bottom: 5px;
  }
  
  .experience-label {
    font-size: 18px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--header-text-dark);
  }
  
  .experience-value {
    font-size: 18px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--header-text-dark);
  }
  
  [data-theme="light"] .experience-label,
  [data-theme="light"] .experience-value {
    color: var(--header-text-light);
  }
  
  .experience-slider {
    width: 100%;
    accent-color: #2173E5;
  }
  
  .switch {
    position: relative;
    display: inline-block;
    width: 52px;
    height: 28px;
  }
  
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0; left: 0;
    right: 0; bottom: 0;
    background-color: #ccc;
    border-radius: 34px;
    transition: 0.2s;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 20px; width: 20px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    border-radius: 50%;
    transition: 0.2s;
  }
  
  input:checked + .slider {
    background-color: #2173E5;
  }
  
  input:checked + .slider:before {
    transform: translateX(24px);
  }

  .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  z-index: 999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: white;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 768px) {

/* контейнер */

.consultant-container{
  width: 100%;
  max-width: 340px;
  padding: 0 20px;
}

/* строка вопроса */

.question-row{
  gap: 12px;
}

/* заголовок */

.title{
  font-size: 16px;
  line-height: 1.3;
}

/* описание */

.subtitle{
  font-size: 13px;
  margin-top: 18px;
}

/* опыт */

.slider-row{
  margin-top: 22px;
}

.experience-label,
.experience-value{
  font-size: 16px;
}

/* слайдер */

.experience-slider{
  margin-top: 8px;
}

/* переключатель чуть меньше */

.switch{
  width: 46px;
  height: 24px;
}

.slider:before{
  height: 18px;
  width: 18px;
}

input:checked + .slider:before{
  transform: translateX(20px);
}

}
  </style>